import { getSystemOffset } from './time';
import { DateTimeFormatter, Duration, Instant, LocalDateTime, OffsetDateTime } from '@js-joda/core';
/**
 * @deprecated Use the replacer from @thinkalpha/common/serialization/serializer.js
 */
export function replacer(key, value) {
    if (value instanceof Instant) {
        return value.toString();
    }
    return value;
}
const ISO_8601_FULL = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;
const ISO_8601_FULL_DURATION = /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d+[HMS])(\d+H)?(\d+M)?([\d.]+S)?)?$/i;
/**
 * @deprecated Use the reviver from @thinkalpha/common/serialization/serializer.js
 */
export function reviver(_key, value) {
    if (typeof value === 'string') {
        if (value.match(ISO_8601_FULL)) {
            const hasTimeZone = value.indexOf('Z') >= 0;
            return hasTimeZone
                ? OffsetDateTime.parse(value, DateTimeFormatter.ISO_OFFSET_DATE_TIME).toInstant()
                : LocalDateTime.parse(value).toInstant(getSystemOffset());
        }
        else if (value.match(ISO_8601_FULL_DURATION)) {
            return Duration.parse(value);
        }
    }
    return value;
}
export function serializeObject(input) {
    const serialized = {};
    for (const [key, value] of Object.entries(input)) {
        serialized[key] = replacer(key, value);
    }
    return serialized;
}
export function reviveObject(input) {
    const revived = {};
    for (const [key, value] of Object.entries(input)) {
        revived[key] = reviver(key, value);
    }
    return revived;
}
